<template>
  <div class="my-search-condition">
    <sn-header text="我的搜索条件" @change="onToggleStatusChange"></sn-header>
    <el-collapse-transition>
      <div class="conditions" v-if="conditionsShow">
        <div class="row existed">
          <div @click="onCheckCollectedData(item.id)" class="row existed-item" v-for="(item, index) in collectedSearchData" :key="index">
            <div class="existed-title">{{item.alias}}</div>
            <div @click.stop="onEditCollected(item.id)" class="edit"></div>
            <div @click.stop="onDelCollected(item.id)" class="del"></div>
          </div>
        </div>
        <div class="history-conditions">
          <div class="history-conditions-title">
            历史搜索条件
          </div>
          <div class="history-conditions-content">
           <div @click="onCheckHistoryData(item.id)" class="row history-conditions-item" v-for="(item, index) in historySearchData" :key="index">
             <div class="conditions-item-img">
              <i @click.stop="onAddConditions(item.id)" class="history-conditions-item-img"></i>
             </div>
             <div class="conditions-item-detail">{{item.company_name}} {{item.keyword}} {{item.filter}}</div>
           </div>
          </div>
        </div>
      </div>
    </el-collapse-transition>
    <el-dialog
      title="添加搜索条件"
      class="add-conditions-content-dialog"
      :visible.sync="historyDialogVisible"
      width="410px"
      >
      <div class="dialog-content">
        <input type="text" class="dialog-input" v-model.trim="addConditionsContentInput"/>
      </div>
      <span slot="footer" class="row dialog-footer">
        <div></div>
        <div>
          <el-button class="btn cancel-btn" @click="onDialogCancel">取消</el-button>
          <el-button class="btn confirm-btn" @click="onDialogConfirm">提交</el-button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="更改搜索条件名称"
      class="add-conditions-content-dialog"
      :visible.sync="renameDialogVisible"
      width="410px"
      >
      <div class="dialog-content">
        <input type="text" class="dialog-input" v-model.trim="renameConditionsContentInput"/>
      </div>
      <span slot="footer" class="row dialog-footer">
        <div></div>
        <div>
          <el-button class="btn cancel-btn" @click="onrenameDialogCancel">取消</el-button>
          <el-button class="btn confirm-btn" @click="onrenameDialogConfirm">提交</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SnHeader from '@/components/common/SnHeader';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      timer: {},
      selectedCollectedData: [],
      renameId: 0,
      renameConditionsContentInput: '',
      renameDialogVisible: false,
      collectedSearchData: [],
      historySearchData: [],
      historyId: 0,
      addConditionsContentInput: '',
      historyDialogVisible: false,
      conditionsShow: true
    };
  },
  props: {
    num: {
      type: Number
    }
  },
  watch: {
    num() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getHistory();
      }, 1000);
    }
  },
  methods: {
    onCheckCollectedData(id) {
      this.selectedCollectedData = this.collectedSearchData.filter(item => {
        if (item.id === id) {
          return true;
          // eslint-disable-next-line
        } else {
          return null;
        }
      });
      this.$emit('mySearchCondition', this.selectedCollectedData[0].question_json);
    },
    onCheckHistoryData(id) {
      this.selectedCollectedData = this.historySearchData.filter(item => {
        if (item.id === id) {
          return true;
          // eslint-disable-next-line
        } else {
          return null;
        }
      });
      this.$emit('mySearchCondition', this.selectedCollectedData[0].question_json);
    },
    onToggleStatusChange(res) {
      this.conditionsShow = res;
    },
    getHistory() {
      QuestionQuery.getHistory(1, 5).then(res => {
        this.historySearchData = res.items;
      });
    },
    getCollectedHistory() {
      QuestionQuery.getCollectedHistory().then(res => {
        this.collectedSearchData = res.items;
      });
    },
    onDialogConfirm() {
      if (!this.addConditionsContentInput) {
        this.$message({
          message: '请输入条件名称',
          duration: 1000,
          type: 'error'
        });
      } else {
        QuestionQuery.historySearchRename(this.historyId, this.addConditionsContentInput).then(() => {
          this.addConditionsContentInput = '';
          this.historyDialogVisible = false;
          this.getCollectedHistory();
        },
        (err) => {
          this.$message({
            message: err.response.data.message,
            duration: 2000,
            type: 'error'
          });
        });
      }
    },
    onAddConditions(id) {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit('unLogin');
      } else {
        this.historyDialogVisible = true;
        this.historyId = id;
      }
    },
    onDialogCancel() {
      this.historyDialogVisible = false;
      this.addConditionsContentInput = '';
    },
    onEditCollected(id) {
      this.renameId = id;
      this.renameConditionsContentInput = '';
      this.renameDialogVisible = true;
    },
    onDelCollected(id) {
      QuestionQuery.deleteCollectedHistory(id).then(() => {
        this.getCollectedHistory();
      });
    },
    onrenameDialogConfirm() {
      if (!this.renameConditionsContentInput) {
        this.$message({
          message: '请输入搜索条件名称',
          duration: 1000,
          type: 'error'
        });
      } else {
        QuestionQuery.historySearchRename(this.renameId, this.renameConditionsContentInput).then(() => {
          this.renameDialogVisible = false;
          this.renameConditionsContentInput = '';
          this.getCollectedHistory();
        },
        (err) => {
          this.$message({
            message: err.response.data.message,
            duration: 2000,
            type: 'error'
          });
        });
      }
    },
    onrenameDialogCancel() {
      this.renameDialogVisible = false;
      this.renameConditionsContentInput = '';
    }
  },
  components: {
    SnHeader
  },
  mounted() {
    eventBus.$on('userLogout', () => {
      this.getCollectedHistory();
    });
    this.getHistory();
    this.getCollectedHistory();
  }
};
</script>
<style lang="scss" scoped>
.my-search-condition {
  .conditions {
    padding: 16px;
    background-color: #ffffff;
    .existed {
      margin-bottom: 16px;
      flex-wrap: wrap;
      max-height: 200px;
      overflow-y: auto;
      .existed-item {
        padding: 0 8px;
        margin-right: 10px;
        margin-bottom: 10px;
        height: 32px;
        line-height: 32px;
        border-radius: 2px;
        border: 1px solid #e5e6ee;
        cursor: pointer;
        &:hover {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #ffffff;
        }
        &:focus {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #ffffff;
        }
        &:active {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #f2f3f7;
        }
        .existed-title {
          font-size: 12px;
          color: #747990;
        }
        .edit {
          margin: 8px 8px 0;
          width: 16px;
          height: 16px;
          line-height: 16px;
          background: url("../../assets/img/edit.svg") no-repeat;
          background-size: cover;
          cursor: pointer;
          &:hover {
            background: url("../../assets/img/edit-hover.svg") no-repeat;
          }
        }
        .del {
          margin-top: 8px;
          width: 16px;
          height: 16px;
          line-height: 16px;
          background: url("../../assets/img/close.svg") no-repeat;
          background-size: cover;
          cursor: pointer;
          &:hover {
            background: url("../../assets/img/close-hover.svg") no-repeat;
          }
        }
      }
    }
    .history-conditions {
      .history-conditions-title {
        color: #747990;
        font-size: 14px;
        font-weight: 500;
      }
      .history-conditions-content {
        padding-top:16px;
        .history-conditions-item {
          margin-bottom: 10px;
          padding: 8px 9px;
          width: 100%;
          // height: 32px;
          // line-height: 32px;
          border-radius: 2px;
          border: 1px solid #e5e6ee;
          font-size: 12px;
          color: #747990;
          cursor: pointer;
          &:hover {
            border: 1px solid #171f46;
            color: #171f46;
            background-color: #ffffff;
          }
          &:focus {
            border: 1px solid #171f46;
            color: #171f46;
            background-color: #ffffff;
          }
          &:active {
            border: 1px solid #171f46;
            color: #171f46;
            background-color: #f2f3f7;
          }
          .conditions-item-img {
            margin-right: 9px;
            .history-conditions-item-img {
              display: block;
              width: 16px;
              height: 16px;
              background: url("../../assets/img/add-search-condition.svg") no-repeat;
              background-size: cover;
              cursor: pointer;
              &:hover {
                background: url("../../assets/img/add-search-condition-hover.svg") no-repeat;
              }
            }
          }
          .conditions-item-detail {
            width: 300px;
            word-wrap: break-word;
          }
        }
      }
    }
  }
}
 /deep/.add-conditions-content-dialog {
    .dialog-input {
      width: 352px;
      height: 40px;
      padding-left: 16px;
      border-radius: 2px;
      border: solid 1px #e5e6ee;
      color: #171f46;
      outline: none;
      &:hover {
        border: solid 1px #999ebe;
      }

      &:focus {
        border: solid 1px #171f46;
      }
    }
    .el-dialog {
      box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
      border-radius: 2px;
      border: solid 1px #f7f7fa;
      .el-dialog__header {
        padding: 24px 24px 14px;
        .el-dialog__title {
          font-size: 16px;
        }
      }
      .el-dialog__body {
        max-height: 300px;
        overflow: auto;
        padding: 0 24px 16px;
      }
      .el-dialog__footer {
        padding: 0 24px 24px;
      }
    }
}
.dialog-footer {
  justify-content: space-between;
  .cancel-btn {
    width: 60px;
    color: #171f46;
    background-color: rgba(0, 11, 92, 0.03);
    &:hover {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
    background-blend-mode: normal, normal;
    }
  }
  .btn {
    height: 32px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
  }
  .confirm-btn {
    width: 60px;
    color: #ffffff;
    background-color: #0055ff;
    &:hover {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
  }
}
</style>
